import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch } from '../..';
import { IAppSlice, IAppSliceConfig, IContentProductIds } from '../../../types';
import { pollWindowVariables } from '../../../utils';
import { fetchProducts } from '../products/products';

const app = createSlice({
  name: 'app',
  initialState: {
    initialized: false,
    loading: true,
    config: {
      currency: null,
      localeId: '',
      siteId: '',
      uplayData: {
        ready: true,
        authenticated: false,
        'subscription-status' : false
      }
    }
  } as IAppSlice,
  reducers: {
    setupStarted(state) {
      state.loading = true;
    },
    setupApp(state, action: PayloadAction<IAppSliceConfig>) {
      state.config = action.payload;
      state.loading = false;
      state.initialized = true;
    },
    startLoading(state) {
      state.loading = true;
    },
    endLoading(state) {
      state.loading = false;
    }
  }
});

export const { setupStarted, setupApp, startLoading, endLoading } = app.actions;

export default app.reducer;

export const fetchAppSetup = (ids?: IContentProductIds) => async (
  dispatch: AppDispatch
) => {
  try {
    dispatch(setupStarted());
    const windowVariablesPromises = await pollWindowVariables([
      'uplayData',
      'GeoRestrictedResources',
      'Constants'
    ]);

    const promiseValues = await Promise.all(windowVariablesPromises);
    const config: IAppSliceConfig = {
      currency: (promiseValues[1] as any).STOREFRONT_CURRENCY_CODE,
      localeId: (promiseValues[1] as any).STOREFRONT_CURRENT_LOCALE,
      siteId: (promiseValues[2] as any).SITE_ID,
      uplayData: {
        ready: true,
        ...(promiseValues[0] as object)
      }
    };

    if (ids) {
      await dispatch(fetchProducts(ids));
    }

    await dispatch(setupApp(config));
  } catch (error) {
    console.log('App Setup Error: ', error);
  }
};
